module.exports = __webpack_public_path__ + "static/media/tank (1).b9011652.svg";